<template>
  <div class="form-checkbox__wrap">
    <div class="collapsible">
      <div class="collapsible__title" :class="{'is-opened': isOpened, 'without-content': withoutContent}">
        <label class="collapsible__checkbox-wrapper">
          <input
            ref="checkbox"
            :class="{error: showError}"
            value="value"
            v-model="model"
            @click="handleChange"
            :disabled="disabled"
            type="checkbox">
          <span class="form-checkbox"></span>
        </label>
        <div class="text" @click="handleTitleClick">
          <slot name="text" />
        </div>
      </div>
      <span class="error-message" v-show="showError">To pole jest wymagane.</span>
      <transition name="slide-down">
        <div class="collapsible__content" v-show="isOpened">
          <slot name="content" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleCheckbox',
  props: {
    value: {
      type: Boolean,
      required: false
    },
    showError: {
      type: Boolean | undefined,
      required: true
    },
    opened: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data () {
    return {
      model: false,
      isOpened: false,
    }
  },
  computed: {
    withoutContent () {
      return !this.$slots.content
    }
  },
  mounted () {
    if (this.value !== undefined) this.model = this.value
    this.isOpened = this.opened
  },
  watch: {
    value: function (val, oldVal) {
      this.model = val
    },
    opened: function (val, oldVal) {
      if (!oldVal && val) this.isOpened = true
    },
    isOpened: function (val) {
      this.$emit('openedToggle', val)
    }
  },
  methods: {
    handleChange (event) {
      const isChecked = event.target.checked
      this.$emit('input', isChecked)
      this.$emit('change', isChecked)
    },
    handleTitleClick (e) {
      this.isOpened = !this.isOpened
      if (this.withoutContent) this.$refs.checkbox.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__checkbox-wrapper {
    display: flex;
    align-items: center;
  }

  &__title {
    display: flex;
    position: relative;
    cursor: pointer;
    align-items: center;
    text-align: left;
    -webkit-tap-highlight-color: transparent;

    .text {
      width: 100%;
      padding: 5px 30px 5px 0;
      font-weight: 500;
      color: var(--white);
      p {
        font-weight: 500;
      }
    }

    &::after {
      pointer-events: none;
      content: '';
      width: 9px;
      height: 9px;
      position: absolute;
      top: 10px;
      right: 10px;
      transition: 0.3s;
      border: solid var(--white, #b2b2b2);
      border-width: 0 2px 2px 0;
      display: inline-block;
      transform: rotate(45deg);
    }

    &.is-opened {
      &::after {
        transform: rotateZ(-135deg);
      }
    }

    &.without-content {
      &::after {
        border: none;
      }
    }
  }

  &__content {
    display: flex;
    position: relative;
    flex-direction: column;
    overflow: hidden;
    margin-left: 20px;
  }

  .error-message {
    padding-left: 25px;
  }
}

.slide-down-enter-active {
  transition: max-height 0.5s ease-in;
}

.slide-down-leave-active {
  transition: max-height 0.3s ease-out;
}

.slide-down-enter-to,
.slide-down-leave {
  overflow: hidden;
  max-height: 1000px;
}

.slide-down-enter,
.slide-down-leave-to {
  overflow: hidden;
  max-height: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/assetComponents/CollapsibleCheckbox.vue